<template>
    <div class="task-info">
        <div class="info-header">
            <span class="info-header-txt">预约记录</span>
        </div>
        <div class="task-wrapper">
            <el-table :data="appointmentRecordInfo" border class="task-list" width="100%" height="230" @cell-dblclick="cellDblClick" >
                <el-table-column
                    v-for="(item, index) in tableColumn"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label"
                    :width="item.width"
                    :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div v-if='item.type === "photos"' style="line-height: 0px;">
                            <img v-if="scope.row[item.prop]" src="@/assets/photos.png" @click.stop='photosBtn(scope.row)' style="width: 20px; cursor: pointer;">
                        </div>
                    <div v-else>{{ scope.row[item.prop] }}</div>
                 </template>
                </el-table-column>
        </el-table>
        </div>
        <!-- 图片预览 -->
        <attachment-dialog v-if='attachmentShow' :attachmentShow.sync='attachmentShow' :rowData='rowData'>
        </attachment-dialog>
    </div>
</template>

<script>
import { copyToClip } from '../../util';
import attachmentDialog from './attachmentDialog';

export default {
    name: 'AppointmentRecord',
    components: { attachmentDialog },
    props: {
        appointmentRecordInfo: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            attachmentShow: false,
            rowData: {},
            tableColumn: [
                { prop: 'appointmentTimes', label: '预约时间', width: '180' },
                { prop: 'appointmentInstallTimes', label: '预约安装时间', width: '180' },
                { prop: 'appointmentWayName', label: '预约类型', width: '180' },
                { prop: 'reasonValue', label: '改约原因', width: '220' },
                { prop: 'requireInstallTypeName', label: '送装需求', width: '140' },
                { prop: 'appointmentExceptionValue', label: '预约异常', width: '220' },
                { prop: 'remark', label: '备注', width: '180' },
                { prop: 'propertiesList', label: '附件', width: '120', type: 'photos' },
                { prop: 'intervieweeMessage', label: '被回访人信息', width: '160' },
                { prop: 'operateSystem', label: '操作系统', width: '100' },
                { prop: 'createTime', label: '操作时间', width: '160' },
                { prop: 'createUserName', label: '操作人', width: '100' }
            ]
        };
    },
    methods: {
        /**
         * @description 双击复制单元格信息
         */
        cellDblClick (row, column, cell, event) {
            if (row[column.property] === null || row[column.property] === undefined) return;
            const value = row[column.property];
            copyToClip(value);
        },
        photosBtn (data) {
            this.rowData = data;
            this.attachmentShow = true;
        }
    }
};
</script>

<style lang="less" scoped>
@import '../appointmentDetail.less';
.task-info {
    background-color: #fff;
    margin-bottom: 10px;
}
.task-wrapper {
    padding: 10px;
}
</style>
